export var ExternalProviderOperationTypeEnum;
(function (ExternalProviderOperationTypeEnum) {
    ExternalProviderOperationTypeEnum["TRANSFER"] = "TRANSFER";
    ExternalProviderOperationTypeEnum["EXCHANGE_QUOTE"] = "EXCHANGE_QUOTE";
    ExternalProviderOperationTypeEnum["EXCHANGE_MARKET"] = "EXCHANGE_MARKET";
})(ExternalProviderOperationTypeEnum || (ExternalProviderOperationTypeEnum = {}));
//# sourceMappingURL=external-provider-operation-type.enum.js.map